import { useMsal } from "@azure/msal-react";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Box, Button, CircularProgress, MenuItem, MenuList, Modal, Popover, Stack, TextField, Typography, styled, Select, Autocomplete, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import Alert from "@mui/material/Alert";
import LinearProgress from "@mui/material/LinearProgress";
import Snackbar from "@mui/material/Snackbar";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import axios from "axios";
import { AlignmentType, Document, HeadingLevel, Packer, Paragraph, TextRun } from "docx";
import { saveAs } from "file-saver";
import Markdown from "markdown-to-jsx";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addUser } from "../Redux/UserMaintanence";
import { baseURL } from "../Constant";
import Regeneratepopup from "../MailComponent/Regenratepopup";
import { fetchStartReviewTime, handleApproverUpdatedContent, handleDataApprpval, updateStartReviewTime } from "../Redux/Approver";
import ApproverConfimPopup from "./ApproverConfimPopup";
import "./ApproverMailGeneration.css";
import FeedbackForm from "./FeedbackForm";
import ChooseDesigner from "./ChooseDesigner";
const CustomButton = styled(Button)(({
  theme
}) => ({}));
const theme = createTheme({
  typography: {
    fontFamily: "Graphik-Regular"
  },
  typography: {
    subtitle1: {
      fontFamily: "Graphik-Medium"
    }
  }
});
const TopAlert = ({
  open,
  onClose,
  severity,
  message
}) => {
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    if (open) {
      setProgress(0);
      const timer = setInterval(() => {
        setProgress(prev => prev >= 100 ? 100 : prev + 2); // Increment progress every 100ms
      }, 100);
      const closeTimer = setTimeout(() => {
        onClose();
      }, 5000); // Close after 5 seconds

      return () => {
        clearInterval(timer);
        clearTimeout(closeTimer);
      };
    }
  }, [open, onClose]);
  return <Snackbar open={open} anchorOrigin={{
    vertical: "top",
    horizontal: "right"
  }} sx={{
    top: "100px !important"
  }} onClose={onClose}>
   <Alert onClose={onClose} severity={severity} sx={{
      width: "100%",
      position: "relative"
    }}>
    {message}
    <LinearProgress variant="determinate" value={progress} color="success" sx={{
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%",
        color: "success"
      }} />
   </Alert>
  </Snackbar>;
};
const ApproverMailGeneration = ({
  setL2,
  selectedMail,
  setSelectedMail,
  uniqueID,
  setActiveScreen,
  userData,
  status,
  program,
  type
}) => {
  const {
    data,
    trackLoading: loading
  } = useSelector(state => state?.track);
  const activetracks = data.filter(track => track.isActive);
  const [isEditing, setIsEditing] = useState(false);
  const [open, setOpen] = useState(false);
  const [isLoading, setIsloading] = React.useState(false);
  const dispatch = useDispatch();
  const [isSaveClicked, setIsSaveClicked] = useState(false);
  const [openUserData, setOpenUserData] = useState(false);
  const currentStatus = useSelector(state => state.approver.currentStatus);
  const isReviewStarted = useSelector(state => state.approver.isReviewStarted);
  const isStatusSubmission = useSelector(state => state.approver.isStatusSubmission);
  const requestorData = userData;
  const [openConfirmPopup, setOpenConfirmPopup] = useState(false);
  const {
    instance
  } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const [approver, setApprover] = useState(null);
  const [buttonValue, setbuttonValue] = useState("");

  // alert
  const [alertOpen, setAlertOpen] = useState(false);
  const [alerText, setAlertText] = useState("");
  const [saveAlertText, setSaveAlertText] = useState("");

  //feedback modal
  const [openModal, setOpenModal] = useState(false);
  const [isFeedbackSuccess, setIsFeedbackSuccess] = useState(null);
  const {
    UserMaintanenceData
  } = useSelector(state => state.userRoles);

  //self or On-behalf modal
  const [openSOB, setOpenSOB] = useState(false);
  const [onBehalfValue, setOnBehalfValue] = useState('');
  const [selectedOption, setSelectedOption] = useState('actual');
  const [inputValue, setInputValue] = useState('');
  const [addingNewEntId, setAddingNewEntId] = useState(false);
  const [newEntId, setNewEntId] = useState("");
  const [newTrackVal, setNewTrackVal] = useState("");
  const handleSOBClose = () => setOpenSOB(false);
  const handleRadioChange = event => {
    setSelectedOption(event.target.value);
  };
  // const transformedUsers = UserMaintanenceData.map((user) => ({
  //   label: user.Enterprise_ID,
  //   id: user.Enterprise_ID,
  // }));
  const handleSOBSubmit = e => {
    e.preventDefault();
    if (selectedOption === 'behalf') {
      if (!onBehalfValue) {
        alert("Please choose a person on behalf of whom communication is requested!");
      } else {
        dispatch(updateStartReviewTime(uniqueID, onBehalfValue));
        handleSOBClose();
      }
    } else {
      dispatch(updateStartReviewTime(uniqueID, null));
      handleSOBClose();
    }
  };
  const handleSubmitOfNewuser = e => {
    e.preventDefault();
    if (UserMaintanenceData.some(user => user.Enterprise_ID === newEntId)) {
      alert("User with this enterpriseId already exists");
      return;
    }
    dispatch(addUser(newEntId, newTrackVal, {
      guest_cb: true
    }));
    setAddingNewEntId(false);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const handleShowAlert = () => {
    setAlertText(isStatusSubmission ? buttonText == "Approve" ? "Content approved successfully !!!" : "Request discarded successfully !!!" : "Sorry..Unexpected error please try again later");
    setSaveAlertText(isStatusSubmission ? "Content saved successfully !!!" : "Sorry..Unexpected error please try again later");
    setAlertOpen(true);
  };
  const handleCloseAlert = () => {
    setAlertOpen(false);
  };
  const handleTextClick = () => {
    if (status == 1 || currentStatus == 1 || status == 0 || currentStatus == 0) {
      setIsEditing(false);
    } else {
      setIsEditing(true);
    }
  };
  let apiType = null;
  if (type == "Teaser") {
    apiType = "teaser";
  } else if (type == "Reminder") {
    apiType = "reminder";
  } else if (type == "Nudge") {
    apiType = "nudge";
  } else if (type == "Recognition") {
    apiType = "recognition";
  } else if (type == "Closure") {
    apiType = "closure";
  } else if (type == "E-Certificate") {
    apiType = "certificate";
  } else if (type == "Testimonial") {
    apiType = "testimonial";
  } else if (type == "Viva-Launch/Nomination/Registration") {
    apiType = "vivaLaunchNewContent";
  } else if (type == "Viva-Follow-up/Reminder") {
    apiType = "vivaReminderNewContent";
  } else if (type == "Viva-Nudge") {
    apiType = "vivaNudgeNewContent";
  } else if (type == "Viva-Recognition") {
    apiType = "vivaRecognitionNewContent";
  } else if (type == "Dipa-Teaser") {
    apiType = "dipaTeaserNewContent";
  } else if (type == "Dipa-Launch") {
    apiType = "dipaLaunchNewContent";
  }
  function handleRegeneration(userquery) {
    setIsloading(true);
    let values = {
      currentContent: selectedMail,
      userquery: userquery,
      sessionID: localStorage.getItem("sessionId")
    };
    if (type == "Launch") {
      axios.post(`${baseURL}/fetchresponse`, {
        values
      }).then(response => {
        // then print response status
        setSelectedMail(response.data);
        setIsloading(false);
      }).catch(err => {
        // then print response status
        console.error("upload fail", err);
        setIsloading(false);
      });
    } else {
      axios.post(`${baseURL}/${apiType}/fetchresponse`, {
        values
      }).then(response => {
        // then print response status
        setSelectedMail(response.data);
        setIsloading(false);
      }).catch(err => {
        // then print response status
        console.error("upload fail", err);
        setIsloading(false);
      });
    }
  }
  useEffect(() => {
    if (activeAccount) {
      setApprover(activeAccount.idTokenClaims.enterpriseID);
    }
  }, [activeAccount]);
  useEffect(() => {
    dispatch(fetchStartReviewTime(uniqueID));
  }, []);
  const handleTextChange = event => {
    setSelectedMail(event.target.value);
  };
  const handleSave = () => {
    let values = {
      template: selectedMail,
      uniqueID: uniqueID
    };
    setIsSaveClicked(true);
    dispatch(handleApproverUpdatedContent(values));
    handleShowAlert();
  };
  const handleActionButtonClick = (e, buttontext) => {
    setbuttonValue(buttonText);
    if (!(status == 1 || currentStatus == 1 || status == 0 || currentStatus == 0 || !isReviewStarted)) {
      e.preventDefault();
      setOpenConfirmPopup(true);
    }
  };
  const handleMailerStatus = () => {
    setIsSaveClicked(false);
    let val;
    if (buttonValue == "Approve") {
      val = 1;
    } else if (buttonValue == "Not Applicable") {
      val = 0;
    }
    const detail = {
      status: val,
      uniqueID: uniqueID,
      template: selectedMail,
      approver: approver
    };
    dispatch(handleDataApprpval(detail));
    handleShowAlert();
  };
  const downloadWordDocument = async () => {
    try {
      const doc = new Document({
        sections: [{
          properties: {},
          children: convertMarkdownToParagraphs(selectedMail)
        }]
      });
      const blob = await Packer.toBlob(doc);
      {
        saveAs(blob, `${program}_${type}.docx`);
      }
    } catch (error) {
      console.error("Error generating document:", error);
    }
  };
  const convertMarkdownToParagraphs = markdown => {
    const lines = markdown.split("\n");
    return lines.map(line => {
      const cleanedLine = line.replace(/\*\*/g, "");
      if (cleanedLine.startsWith("# ")) {
        return new Paragraph({
          children: [new TextRun({
            text: cleanedLine.replace("# ", ""),
            font: "Aptos" // Font family
          })],
          heading: HeadingLevel.HEADING_1,
          alignment: AlignmentType.LEFT
        });
      } else if (cleanedLine.startsWith("## ")) {
        return new Paragraph({
          children: [new TextRun({
            text: cleanedLine.replace("# ", ""),
            font: "Aptos" // Font family
          })],
          heading: HeadingLevel.HEADING_2,
          alignment: AlignmentType.LEFT
        });
      } else if (cleanedLine.startsWith("- ")) {
        return new Paragraph({
          children: [new TextRun({
            text: cleanedLine.replace("- ", ""),
            font: "Aptos" // Font family
          })],
          bullet: {
            level: 0
          }
        });
      } else if (cleanedLine.startsWith("**")) {
        return new Paragraph({
          children: [new TextRun({
            text: cleanedLine,
            //  bold: true,
            font: "Aptos" // Font family
          })]
        });
      } else if (cleanedLine.startsWith("📢 ")) {
        return new Paragraph({
          children: [new TextRun({
            text: cleanedLine,
            font: "Aptos"
          })]
        });
      } else {
        return new Paragraph({
          children: [new TextRun({
            text: cleanedLine,
            font: "Aptos" // Font family
          })]
        });
      }
    });
  };

  // dropdown popover
  const [anchorEl, setAnchorEl] = useState(null);
  const [buttonText, setButtonText] = useState(status == -1 ? "Approve" : status == 1 || currentStatus == 1 ? "Approved" : "Not Applicable");
  const handleClick = event => {
    if (status == 1 || currentStatus == 1 || status == 0 || currentStatus == 0 || !isReviewStarted) {
      event.preventDefault();
    } else {
      setAnchorEl(event.currentTarget);
    }
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleMenuItemClick = option => {
    setButtonText(option);
    handleClose();
  };
  const open1 = Boolean(anchorEl);
  const id = open1 ? "simple-popover" : undefined;
  const options = ["Approve", "Not Applicable"];
  useEffect(() => {
    setTimeout(() => {
      setIsFeedbackSuccess(null);
    }, 4000);
  }, [isFeedbackSuccess]);
  return <>
   <ThemeProvider theme={theme}>
    <Stack sx={{
        alignItems: "center"
      }}>
     {/* <Stack
      sx={{
       borderBottom: "1px solid #b5c1e7",
       width: "97%",
       height: "50px",
       justifyContent: "center",
      }}
      >
      <Stack direction={"row"} justifyContent={"space-between"} sx={{}}>
       <Stack direction={"row"} spacing={0.5}>
        <Typography variant="subtitle1">
         Approval <span>{">"}</span>
        </Typography>
          <Typography
         sx={{
          fontFamily: "Grpahik-Bold !importanrt",
          fontWeight: "600",
         }}
         variant="subtitle1"
        >
         AI Generated Content
        </Typography>
       </Stack>
         <WelcomeName />
      </Stack>
      </Stack> */}
     <Stack sx={{
          height: "500px",
          margin: "15px 0px 30px 20px",
          position: "relative",
          width: "100%",
          marginLeft: "40px"
        }}>
      {isReviewStarted && status != 1 && status != 0 && currentStatus != 1 && currentStatus != 0 && <Box sx={{
            width: "90%",
            display: "flex",
            justifyContent: "end"
          }}>
         <Typography sx={{
              color: "green",
              fontWeight: "700"
            }}>
          The review process has started.
         </Typography>
        </Box>}
      {isLoading && <Box display="flex" flexDirection="column" alignItems="center" sx={{
            height: "100%",
            justifyContent: "center"
          }}>
        <CircularProgress />
        <Typography variant="h6" marginTop={2}>
         Generating...
        </Typography>
       </Box>}

      {!isLoading && selectedMail != null && <Stack>
        <Stack spacing={2} sx={{
              height: "450px",
              borderBottom: "solid 1px #b5c1e7"
            }}>
         <style>
          {`
                    .highlight {
                        font-weight: bold;
                        color: black;
                    }
                `}
         </style>

         {isEditing ? <TextField value={selectedMail} onChange={handleTextChange} autoFocus multiline fullWidth sx={{
                height: "500px",
                border: "none !important",
                overflow: "scroll"
              }} variant="standard" InputProps={{
                disableUnderline: true
              }} /> : <div onClick={handleTextClick} className="migrated-style-approvermailgeneration-068900-1">
           <Markdown options={{
                  overrides: {
                    p: {
                      props: {
                        style: {
                          fontSize: "14px",
                          fontFamily: "Graphik-Regular"
                        }
                      }
                    },
                    li: {
                      props: {
                        style: {
                          fontSize: "14px",
                          fontFamily: "Graphik-Regular"
                        }
                      }
                    }
                  }
                }}>
            {selectedMail}
           </Markdown>
          </div>}
        </Stack>
        {userData != null && userData != undefined && userData.length != 0 && <Stack sx={{
              width: "100%",
              background: "#F0F0F0",
              padding: "10px"
            }} spacing={0.5} direction={"row"} alignItems={"baseline"}>
          <Typography sx={{
                fontFamily: "Graphik-Medium",
                fontSize: "15px",
                margin: "0px 10px 0px 10px"
              }}>
           Additional Notes By Requestor :{" "}
           <span className="migrated-style-approvermailgeneration-068900-2">
            {userData}
           </span>
          </Typography>
          <Typography></Typography>
         </Stack>}
       </Stack>}

      <Stack direction={"row"} sx={{
            padding: "30px 0px 0px 0px",
            marginRight: "20px",
            marginBottom: "20px"
          }} justifyContent={"space-between"} alignItems={"center"}>
       <Stack direction={"row"} alignItems={"center"}>
        <CustomButton onClick={() => {
                setActiveScreen("default");
                setL2(""); //hides breadcrums and make tabs visible.
              }}>
         <img src={process.env.PUBLIC_URL + "/Images/ApprovalPage/backbutton.png"} className="migrated-style-approvermailgeneration-068900-3"></img>
        </CustomButton>

        <CustomButton onClick={() => {
                setOpenSOB(true);
              }}>
         <img src={isReviewStarted ? process.env.PUBLIC_URL + "/Images/ApprovalPage/startReviewInactive.png" : process.env.PUBLIC_URL + "/Images/ApprovalPage/startReviewActive.png"} className="migrated-style-approvermailgeneration-068900-4"></img>
        </CustomButton>

        <CustomButton onClick={() => {
                setOpen(true);
              }} disabled={!isReviewStarted ? true : currentStatus == 1 || currentStatus == 0 ? true : status == 1 || status == 0 ? true : false}>
         <img src={!isReviewStarted ? process.env.PUBLIC_URL + "/Images/ApprovalPage/regeneratebuttoninactive.png" : currentStatus == 1 || currentStatus == 0 ? process.env.PUBLIC_URL + "/Images/ApprovalPage/regeneratebuttoninactive.png" : status == 1 || status == 0 ? process.env.PUBLIC_URL + "/Images/ApprovalPage/regeneratebuttoninactive.png" : process.env.PUBLIC_URL + "/Images/ApprovalPage/regeneratebutton.png"} className="migrated-style-approvermailgeneration-068900-5"></img>
        </CustomButton>
        <CustomButton onClick={() => {
                handleSave();
                setIsEditing(false);
              }} disabled={!isReviewStarted ? true : currentStatus == 1 || currentStatus == 0 ? true : status == 1 || status == 0 ? true : false}>
         <img src={!isReviewStarted ? process.env.PUBLIC_URL + "/Images/ApprovalPage/savebuttoninactive.png" : currentStatus == 1 || currentStatus == 0 ? process.env.PUBLIC_URL + "/Images/ApprovalPage/savebuttoninactive.png" : status == 1 || status == 0 ? process.env.PUBLIC_URL + "/Images/ApprovalPage/savebuttoninactive.png" : process.env.PUBLIC_URL + "/Images/ApprovalPage/savebutton.png"} className="migrated-style-approvermailgeneration-068900-6"></img>
        </CustomButton>

        <Stack spacing={2} direction={"row"} sx={{
                alignItems: "center"
              }}>
         {/* <Typography sx={{ fontSize: "14px" }}>Status:</Typography> */}

         <Stack direction={"row"} spacing={2} sx={{
                  alignItems: "center",
                  background: !isReviewStarted ? "#B0B0B0" : status == 1 || currentStatus == 1 || status == 0 || currentStatus == 0 ? "#B0B0B0" : "#0041F0",
                  borderRadius: "20px",
                  padding: "2px 10px 2px 10px",
                  height: "25px"
                }}>
          <Typography sx={{
                    color: "white",
                    cursor: !isReviewStarted ? "arrow" : status == 1 || currentStatus == 1 || status == 0 || currentStatus == 0 ? "arrow" : "pointer"
                  }} onClick={e => {
                    handleActionButtonClick(e, buttonText);
                  }}>
           {buttonText}
          </Typography>

          <KeyboardArrowDownIcon onClick={handleClick} sx={{
                    color: "white",
                    borderLeft: "solid 1px white",
                    cursor: !isReviewStarted ? "arrow" : status == 1 || currentStatus == 1 || status == 0 || currentStatus == 0 ? "arrow" : "pointer"
                  }} />
          <Popover id={id} open={open1} anchorEl={anchorEl} onClose={handleClose} anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left"
                  }}>
           <MenuList>
            {options.map(option => <MenuItem key={option} onClick={() => handleMenuItemClick(option)}>
              {option}
             </MenuItem>)}
           </MenuList>
          </Popover>
         </Stack>
        </Stack>
        <CustomButton onClick={() => {
                downloadWordDocument();
              }} disabled={status == 1 || currentStatus == 1 ? false : true}>
         <img src={status == 1 || currentStatus == 1 ? process.env.PUBLIC_URL + "/Images/ApprovalPage/downloadbuttonactive.png" : process.env.PUBLIC_URL + "/Images/ApprovalPage/downlaodbuttoninactive.png"} className="migrated-style-approvermailgeneration-068900-7"></img>
        </CustomButton>
        {/* <div className="feedback-icon-wrap" onClick={() => setOpenModal(true)}>
         <RateReviewIcon fontSize="small" />
         <span>Feedback</span>
         </div> */}
       </Stack>
       <div className="feedback-modal">
        <Modal
              // hideBackdrop
              open={openModal} onClose={handleCloseModal} aria-labelledby="child-modal-title" closeAfterTransition aria-describedby="child-modal-description" className="modal-container">
         <Box className="model">
          <div className="model-header-wrap">
           <div className="model_heading migrated-style-approvermailgeneration-068900-8">
            <h5 className="paramodel">Please help us to serve you better</h5>
           </div>
           <CloseIcon sx={{
                      cursor: "pointer"
                    }} onClick={handleCloseModal} />
          </div>

          <hr />
          <FeedbackForm handleCloseModal={handleCloseModal} uniqueID={uniqueID} isFeedbackSuccess={isFeedbackSuccess} setIsFeedbackSuccess={setIsFeedbackSuccess} />
         </Box>
        </Modal>
       </div>
       {/* Declaration- self or on behalf of  [SOB]*/}
       
       <Modal open={openSOB} onClose={handleSOBClose}>
        <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: "60vw",
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: 4,
                borderRadius: 2
              }}>
          <Typography variant="h6" component="h2" mb={2}>
            Please verify if this communication is requested by the actual requestor or on behalf of someone.
          </Typography>
          <RadioGroup value={selectedOption} onChange={handleRadioChange} name="communication-radio-group" row>
            <FormControlLabel value="actual" control={<Radio />} label="Actual Requestor" />
            <FormControlLabel value="behalf" control={<Radio />} label="On behalf of someone" />
          </RadioGroup>
          {selectedOption === 'behalf' && <Box mt={2}>
              <Typography variant="body1" mb={1}>
                Select the person on behalf of whom you are requesting:
              </Typography>
              <Grid container spacing={2}>
                         <Grid xs={5} id="autocomplete">
                           <Autocomplete required options={inputValue.length > 0 ? UserMaintanenceData.map(user => user.Enterprise_ID) : []} getOptionLabel={option => option} value={onBehalfValue} inputValue={inputValue} // Track the input value
                      onInputChange={(event, newInputValue) => setInputValue(newInputValue)} // Update inputValue
                      onChange={(event, newValue) => setOnBehalfValue(newValue)} // Update selected value
                      renderInput={params => <TextField {...params} label="Select Person" variant="outlined" />} disablePortal slotProps={{
                        popper: {
                          sx: {
                            '& .MuiAutocomplete-listbox': {
                              maxHeight: 100,
                              // Set the max height
                              overflowY: 'auto' // Enable scrolling
                            }
                          }
                        }
                      }} />
                         </Grid>
                         <Grid xs={7}>
                           <span className="instruction">
                            <strong>Note: </strong>
                            <em>If the user or enterprise id does not exist then:
                              <br />
                              1. <span className="span-link" onClick={() => setAddingNewEntId(true)}>Click here</span> to add the new user.
                              <br /> 
                              2. Select the newly added user in this input.  
                              </em>
                              </span>
                         </Grid>
                       </Grid> 
              {addingNewEntId && <form onSubmit={handleSubmitOfNewuser} className="adduser-form">            
              <Grid container spacing={2}>
              <Grid xs={8}>
              <TextField sx={{
                          width: "45%",
                          margin: "5px"
                        }} value={newEntId} onChange={e => setNewEntId(e.target.value)} placeholder="Enter enterprise id here..." required />
              <Select displayEmpty value={newTrackVal} required sx={{
                          width: "45%",
                          margin: "5px"
                        }} onChange={e => setNewTrackVal(e.target.value)}>
                <MenuItem value="" disabled>
                  Choose track
                </MenuItem>
                {activetracks?.map(track => <MenuItem value={track.id}>{track.title}</MenuItem>)}
              </Select>
              </Grid>
              <Grid xs={4} display="flex" justifyContent="center" alignItems="center">
              
              <Button variant="outlined" type="submit" size="small" sx={{
                          margin: "5px"
                        }}>Add</Button>
              <Button variant="outlined" color="error" size="small" sx={{
                          margin: "5px"
                        }} onClick={() => setAddingNewEntId(false)}>Discard</Button>
              </Grid>
              </Grid>
              <div className="instruction migrated-style-approvermailgeneration-068900-9"> 
                Ex: lakshay.c.gupta <br />               
                <strong>Note: </strong>
                <em>If the track does not exist, it must be added by admin via "Track Details" option</em>
              </div>
              </form>}          

            </Box>}
          <Box mt={3} textAlign="right">
            <Button onClick={handleSOBClose} color="secondary">
              Cancel
            </Button>
            <Button variant="contained" color="primary" onClick={handleSOBSubmit} sx={{
                    ml: 2
                  }} disabled={selectedOption === "behalf" && !onBehalfValue}>
              Submit
            </Button>
          </Box>
        </Box>
      </Modal>

      
       {/* <CustomButton
        onClick={() => {
        setOpenUserData(true);
        }}
        disabled={
        userData != null && userData != undefined && userData.length != 0 ? false : true
        }
        >
        {" "}
        <img
        style={{
         width: "20px",
         cursor:
          userData != null && userData != undefined && userData.length != 0
           ? "pointer"
           : "progress",
        }}
        src={
         process.env.PUBLIC_URL + "/Images/ApprovalPage/addiitionalinformationicon.png"
        }
        ></img>
        </CustomButton> */}
      </Stack>
      <Stack sx={{
            paddingBottom: "10px"
          }}>
       <Typography sx={{
              display: "flex",
              gap: "5px"
            }}>
        <ArrowForwardIcon sx={{
                width: "1.5%"
              }} />
        Please press "Back" button to go back to the Approval page.
       </Typography>
      </Stack>
      {!isReviewStarted && <Stack sx={{
            paddingBottom: "150px"
          }}>
        <Typography sx={{
              display: "flex",
              gap: "5px"
            }}>
         <ArrowForwardIcon sx={{
                width: "1.5%"
              }} />
         Please select "Start Review" button before the review.
        </Typography>
       </Stack>}
      <Regeneratepopup open={open} setOpen={setOpen} handleRegeneration={handleRegeneration} requestorData={requestorData} />
      {/* <UserInformationPopup
       open={openUserData}
       setOpen={setOpenUserData}
       userData={userData}
       /> */}
     </Stack>
    </Stack>

    <TopAlert open={alertOpen} onClose={handleCloseAlert} severity={isStatusSubmission == true ? "success" : "error"} message={isSaveClicked ? saveAlertText : alerText} />
    <ApproverConfimPopup openConfirmPopup={openConfirmPopup} setOpenConfirmPopup={setOpenConfirmPopup} handleMailerStatus={handleMailerStatus} buttonText={buttonText} />
   </ThemeProvider>
   <div className="feedback-msg-wrap">
    {isFeedbackSuccess ? <Alert variant="filled" severity="success" onClose={() => setIsFeedbackSuccess(null)}>
      Feedback has been submitted successfully.
     </Alert> : isFeedbackSuccess == false && <Alert variant="filled" severity="error" onClose={() => setIsFeedbackSuccess(null)}>
       There was an error submitting feedback.
      </Alert>}
   </div>
  </>;
};
export default ApproverMailGeneration;
